import { Component, Input } from '@angular/core';
import { WebsiteService } from '../../../../services/website.service';
import Utils from '../../../../shared/utils';

@Component({
  selector: 'app-components-specialist-boost-site-account-read-only',
  templateUrl: './boost-site-account-read-only.component.html'
})
export class BoostSiteAccountReadOnlyComponent {
  @Input() public website: Boo.Objects.Websites.Website;

  utils = Utils;
  url: string;

  constructor(
    private websiteService: WebsiteService
  ) { }

  removeUrl(): void {
    this.url = '';
  }

  getUrl(): void {
    this.websiteService.getSsoUrlForAdmin(this.website.WebsiteId).subscribe(url => this.url = url);
  }

  get boostSiteAccountContainsData(): boolean {
    return this.website && !!(this.website.WebsiteAccount.AccountId || this.website.SiteId);
  }
}
